var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0127 2.142C9.9769 1.28435 8.69287 0.78227 7.35 0.709799V2.45H6.65V0.70945C5.30706 0.782143 4.02302 1.28447 2.98725 2.14235L4.03725 3.19235L3.54235 3.6876L2.47275 2.61765C1.50139 3.61822 0.891056 4.91388 0.738154 6.29999H2.11855V6.99999H0.700004C0.698606 8.41353 1.17522 9.78601 2.0524 10.8944L3.07405 9.87314L3.56895 10.368L2.5172 11.4201L2.5235 11.4268L2.0265 11.9192C0.726561 10.6109 -0.00210208 8.84084 4.55518e-06 6.99649C4.55518e-06 3.1325 3.13425 0 7 0C10.8657 0 14 3.13215 14 6.99649C14.001 7.93423 13.8129 8.86254 13.447 9.72593C13.0811 10.5893 12.5448 11.37 11.8702 12.0214L11.3834 11.5185L11.3876 11.5143L10.1706 10.2973L10.6659 9.80244L11.8629 10.9994C12.7931 9.87436 13.3014 8.45983 13.3 6.99999H11.7894V6.29999H13.2618C13.1089 4.91401 12.4985 3.61847 11.5272 2.618L10.5 3.64455L10.0051 3.15L11.0127 2.142Z",
    fill: "#363636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8194 11.0968C5.80925 11.234 5.84985 11.3702 5.93315 11.4797L6.6062 12.2539C6.99995 12.4254 7.17495 12.4254 7.505 12.2539L8.1777 11.4797C8.261 11.3702 8.3016 11.234 8.2918 11.0968L7.45845 6.26614C7.4077 5.56719 6.69895 5.56089 6.64855 6.25984L5.8194 11.0968Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseTypeIcon);
export default __webpack_public_path__ + "static/media/course-type-icon.af1349c7a955c72278005f201b6a78d8.svg";
export { ForwardRef as ReactComponent };